import { AfterContentInit, OnDestroy, ChangeDetectionStrategy, Component, ContentChildren, input, output, QueryList } from '@angular/core';
import { ToggleItemComponent } from '../toggle-item/toggle-item.component';
import { filter, merge, Subscription } from 'rxjs';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';

@Component({
    selector: 'ca-toggle-group',
    templateUrl: './toggle-group.component.html',
    styleUrl: './toggle-group.component.scss',
    host: {
        '[attr.role]': '"tablist"'
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass]
})
export class ToggleGroupComponent implements AfterContentInit, OnDestroy {
    private selectedItem: ToggleItemComponent;
    private selectedIndex: number;
    disabled = input<boolean>(false);
    select = output<any>();
    subscription?: Subscription;
    @ContentChildren(ToggleItemComponent) items: QueryList<ToggleItemComponent>;

    ngAfterContentInit(): void {
        this.selectIndex(0);
        this.toggleSelection();

        this.subscription = this.items.changes.subscribe(() => {
            this.selectIndex(this.selectedIndex || 0);
            this.toggleSelection();
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    private selectIndex(index: number): void {
        const item: ToggleItemComponent | undefined = this.items.get(index);
        if (!item) {
            return;
        }
        item.selected.set(true);
        this.selectedIndex = index;
        this.selectedItem = item.value();
        this.select.emit(this.selectedItem);
    }

    private toggleSelection(): void {
        const emitters = this.items.map(item => outputToObservable(item.select));
        merge(...emitters)
            .pipe(filter(() => !this.disabled()))
            .subscribe(item => {
                this.selectedItem = item;
                this.items.forEach((option, index) => {
                    option.selected.set(this.selectedItem === option.value());
                    if (this.selectedItem === option.value()) {
                        this.selectedIndex = index;
                    }
                });
                this.select.emit(this.selectedItem);
            });
    }
}
